import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Breadcrumbs, Link, Typography } from "@mui/material";

import { Nutrient } from "api/models";
import { Header2 } from "components/common";
import { useTranslations } from "components/useTranslations";

import useNutrientsDetailsHeaderStyles from "./useNutrientsDetailsHeaderStyles";

export type NutrientsDetailsHeaderProps = {
  nutrient?: Nutrient | undefined;
  displayName?: string;
};

const NutrientsDetailsHeader: React.FC<NutrientsDetailsHeaderProps> = props => {
  const styles = useNutrientsDetailsHeaderStyles();
  const { nutrient, displayName } = props;
  const t = useTranslations();
  return (
    <div className={styles.headerStyling}>
      {nutrient?.key ? (
        <Breadcrumbs separator={<ArrowForwardIcon />}>
          <Link color="inherit" href="/nutrients">
            <Header2>{t`__NUTRIENT_DETAILS_TITLE_EXISTING`}</Header2>
          </Link>
          <Typography color="textPrimary" component="div">
            <Header2>{displayName ?? nutrient?.name}</Header2>
          </Typography>
        </Breadcrumbs>
      ) : (
        <Header2>{t`__NUTRIENT_DETAILS_TITLE_NEW`}</Header2>
      )}
    </div>
  );
};

export default NutrientsDetailsHeader;
